import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './index.scss';

const { array, func } = PropTypes;

class MultiSelect extends React.Component {
  static propTypes = {
    items: array.isRequired,
    onClick: func.isRequired,
    selectedAnswers: array.isRequired,
  };

  itemClicked(itemValue, itemPosition) {
    this.props.onClick(itemValue, itemPosition);
  }

  isSelected(itemValue) {
    return this.props.selectedAnswers.includes(itemValue);
  }

  hasError() {
    return this.props.errors && this.props.errors.length > 0;
  }

  renderError() {
    if (this.hasError()) {
      return (
        <span className="ar-multi_select-error">{this.props.errors[0]}</span>
      );
    }
    return null;
  }

  render() {
    const multiWrapperClasses = classnames('ar-multi_select-wrapper', {
      error: this.hasError(),
    });
    return (
      <div
        data-testid={this.props['data-testid']}
        className={multiWrapperClasses}
      >
        {this.props.items.map((item, i) => {
          const cssClass = this.isSelected(item.text)
            ? 'ar-multi_select-icon af-checkmark brand-bg'
            : 'ar-multi_select-icon';
          return (
            <div
              key={i}
              onClick={this.itemClicked.bind(this, item.text, item.position)}
              className="ar-multi_select-item"
            >
              <span className="ar-multi_select-icon-wrapper">
                <i className={cssClass} data-testid="multi-select-icon" />
              </span>
              <div className="ar-multi_select-text">{item.text}</div>
            </div>
          );
        })}
        {this.props.subtext && (
          <div
            className="question-subtext contains-brand-link"
            dangerouslySetInnerHTML={{ __html: this.props.subtext }}
          />
        )}
        {this.renderError()}
      </div>
    );
  }
}

export default MultiSelect;
